/// <amd-module name="Search/Code/Flux/Stores/SortOptionsStore" />
import * as SharedResources from "Search/Shared/Resources";
import * as Resources from "Search/Code/Resources";
import * as BaseSortOptionsStore from "Search/Shared/Base/Stores/SortOptionsStore";
import { CodeResult, SearchQuery } from "Search/LegacyWebApi/Contracts/Code";;
import { ISortField } from "Search/Shared/Base/Types";
import { ISearchLocalSettingsService } from "Search/Shared/Base/LocalSettingsService";
import { SortActionIds } from "Search/Code/Constants";
import { IVssPageContext } from "VSS/Platform/Context";
import { PreferenceConstants } from "Search/Code/Constants";
import { ISearchStartedPayload } from "Search/Shared/Base/ActionsHub";

export class SortOptionsStore extends BaseSortOptionsStore.SortOptionsStore<CodeResult> {
    constructor(changedEventName: string, pageContext: IVssPageContext, serverSortEnabled: boolean) {
        super(changedEventName);
        this._state.sortOption = serverSortEnabled ? this.relevanceSortOption
            : pageContext
                .getService<ISearchLocalSettingsService>("ISearchLocalSettingsService")
                .getValue(
                    PreferenceConstants.SortOptionKey,
                    this.relevanceSortOption
                );
    }

    public updateSortOptionOnSearch = (payload: ISearchStartedPayload<SearchQuery>) => {
        const { sortOptions } = payload.request;
        this._state.sortOption = sortOptions && sortOptions.length
            ? sortOptions[0]
            : this.relevanceSortOption;

        this.emitChanged();
    }

    public get availableSortFields(): ISortField[] {
        return [
            { key: SortActionIds.Relevance, name: SharedResources.RelevanceSortOption },
            { key: SortActionIds.FilePath, name: Resources.FilePathSortOption },
            { key: SortActionIds.FileName, name: Resources.FileNameSortOption }
        ]
    }

    private get relevanceSortOption() {
        return {
            field: SortActionIds.Relevance,
            sortOrder: SortActionIds.Descending
        };
    }
}
